import { render, staticRenderFns } from "./NextButtom.vue?vue&type=template&id=88be6a00&scoped=true"
import script from "./NextButtom.vue?vue&type=script&lang=js"
export * from "./NextButtom.vue?vue&type=script&lang=js"
import style0 from "./NextButtom.vue?vue&type=style&index=0&id=88be6a00&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88be6a00",
  null
  
)

export default component.exports